import React, {useEffect, useState, useRef} from 'react';
import {NavLink, useSearchParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import Avatar from '../../components/Avatar';
import Loading from '../../components/Loading';
import {fetchDistributors} from '../../slices/distributors.slice';
import PageHeader from '../../components/PageHeader';

const Distributors = () => {
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const { list: distributors, status, error } = useSelector(state => state.distributors);
    const [searchValue, setSearchInput] = useState(searchParams.get('search') || '');
    const debounceRef = useRef(null);

    useEffect(() => {
        const search = searchParams.get('search') || '';
        dispatch(fetchDistributors(search ? { search } : {}));
    }, [dispatch, searchParams]);

    const handleSearch = event => {
        event.preventDefault();
        const value = event.target.value;
        setSearchInput(value);

        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        debounceRef.current = setTimeout(() => {
            const params = new URLSearchParams();
            if (value) {
                params.set('search', value);
            }
            setSearchParams(params);
        }, 300);
    };

    const isLoading = ['idle', 'loading'].includes(status);

    return (
        <div className="distributors-view page px-4 py-3 d-flex flex-column overflow-y-auto">
            <PageHeader
                title='distributors'
                addButtonAction={{navigateTo: '/distributors/new'}}
                searchBar={{searchValue, handleSearch}}
                />
            <div className='contentContainer' >

                {isLoading && <Loading />}

                {error && (
                    <div className="text-center text-uppercase text-expand mt-5">
                        <span className="fas fa-warning fa-3x opacity-50 text-danger my-3 pulse-effect" /><br/>
                        Failed to fetch distributors <br/>
                        <code>{error}</code>
                    </div>
                )}

                {distributors.length > 0 && distributors.map((distributor) => (
                    <NavLink to={`/distributors/${distributor._id}`} key={distributor._id}
                             className="text-decoration-none text-white d-flex align-items-center gap-3 bg-broken p-3 border-start border-primary mb-3">
                        <Avatar imageUrl={distributor.logo?.imageUrl} name={distributor.name} size={50} />
                        <h4 className="my-0 text-primary">{distributor.name}</h4>
                    </NavLink>
                ))}

                {!error && !isLoading && distributors.length === 0 && searchValue && (
                    <div className="text-center text-uppercase text-expand mt-5">
                        <span className="fas fa-search fa-3x opacity-50 text-muted my-3 d-block" />
                        No results found for "{searchValue}"
                    </div>
                )}

                {!error && !isLoading && distributors.length === 0 && !searchValue && (
                    <div className="text-center text-uppercase text-expand mt-5">NO DISTRIBUTORS YET</div>
                )}
            </div>
        </div>
    );
};

export default Distributors;
